import {Distance} from "../Domain/Distance";
import {PartialWorkout} from "../Models/PartialWorkout";
import {Duration} from "../Domain/Duration";
import {WorkoutExecutionType} from "../Models/WorkoutExecutionType";
import {machineTypesContainRp3OrEmpty} from "../Models/MachineType";

export interface IndoorWorkoutListSummary {
    distance: Distance,
    duration: Duration,
    strokeCount: number,
}

export function calculateIndoorWorkoutListSummary(partialWorkout: PartialWorkout): IndoorWorkoutListSummary {

        let validResults = [];

        if (    
                (partialWorkout.execution_type === WorkoutExecutionType.INDOOR) && 
                (partialWorkout.workout_part_results.length > 1) &&
                (machineTypesContainRp3OrEmpty(partialWorkout.machine_configurations)) 
            ) {
            validResults = partialWorkout.workout_part_results.filter(
                (result, index) => index < partialWorkout.workout_part_results.length - 1 || 
                (result.stroke_count !== null && result.stroke_count !== 0)
            );
        } else {
            validResults = partialWorkout.workout_part_results;
        }


        const distance = validResults.reduce(
            (sum, result) => sum.add(result.traveled_distance),
            Distance.fromMillimeters(0),
        );
        const duration = validResults.reduce(
            (sum, result) => sum.add(result.elapsed_time),
            Duration.fromMilliseconds(0),
        );

        const strokeCount = partialWorkout.workout_part_results.reduce((sum, result) => {
            const sC = result.stroke_count;
            if (sC === null) {
                return sum;
            }
            return sum + sC;
        }, 0);

        return {
            distance,
            duration,
            strokeCount,
        }

}
        